// Module
var code = `<button type="button" ng-click="executeBtnClick(\$event)" class="btn {{setType(btnType)}} {{setType(btnSize)}} {{setType(btnContext)}}" ng-disabled="btnDisabled" ng-transclude></button> `;
// Exports
module.exports = code;